import { helpers } from '@vuelidate/validators'
import type { ICheckboxValidator } from './useCheckbox.types'
import type { TInstance } from '@/components/Inputs/Composables/validators/validators.types'

export function useCheckbox(
  field: string,
  t: TInstance,
  options: ICheckboxValidator,

) {
  return ({
    [`${field}`]: {
      ...(options.required && {
        required: helpers.withMessage(
          () => t('formValidatorMessages.checkbox.required'),
          (value) => value === true,
        ),
      }),
    },
  })
}
